import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tabButton', 'imagePane'];

  connect() {
    // Set up event listeners for Bootstrap tab events
    this.tabButtonTargets.forEach((button) => {
      button.addEventListener('shown.bs.tab', this.handleTabShown.bind(this));
    });
  }

  disconnect() {
    // Clean up event listeners
    this.tabButtonTargets.forEach((button) => {
      button.removeEventListener('shown.bs.tab', this.handleTabShown.bind(this));
    });
  }

  handleTabShown(event) {
    const imageTarget = event.target.getAttribute('data-image-target');
    if (imageTarget) {
      // Hide all image panes
      this.imagePaneTargets.forEach((pane) => {
        pane.classList.remove('show', 'active');
      });
      // Show the target image pane
      const targetImagePane = document.querySelector(imageTarget);
      if (targetImagePane) {
        targetImagePane.classList.add('show', 'active');
      }
    }
  }
}

